import React from 'react';
import LocationTemplate from './LocationTemplate';

const NorlinaPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Norlina"
      stateName="North Carolina"
      countyName="Warren"
      zipCodes={["27563"]}
      latitude={36.4421}
      longitude={-78.1975}
      population={1118}
      historicalFact="Named for being on the North Carolina-Virginia line; incorporated in 1905 as a railroad town."
      nearbyTowns={[
        "Warrenton, NC",
        "Henderson, NC",
        "Littleton, NC",
        "Macon, NC",
        "Vaughan, NC",
        "Hollister, NC",
        "Oxford, NC",
        "Louisburg, NC"
      ]}
    />
  );
};

export default NorlinaPage;